

























import Vue from 'vue'
import ProductDetails, { ProductDetailsInterface } from '@/store/catalog/productDetails'
import ProductDetailsPrice from '@/views/components/catalog/productDetails/ProductDetailsPrice.vue'
import ProductDetailsImages from '@/views/components/catalog/productDetails/ProductDetailsImages.vue'
import ProductDetailsTitle from '@/views/components/catalog/productDetails/ProductDetailsTitle.vue'
import ProductDetailsLink from '@/views/components/catalog/productDetails/ProductDetailsLink.vue'
import ProductDetailsCategories from '@/views/components/catalog/productDetails/ProductDetailsCategories.vue'
import ProductDetailsAvailability from '@/views/components/catalog/productDetails/ProductDetailsAvailability.vue'

export default Vue.extend({
  name: 'CatalogInstancesProductDetails',
  components: {
    ProductDetailsAvailability,
    ProductDetailsCategories,
    ProductDetailsLink,
    ProductDetailsTitle,
    ProductDetailsImages,
    ProductDetailsPrice,
  },
  data() {
    return {
      catalogId: 'not-set',
      productId: 'not-set',
    }
  },
  computed: {
    productDetails(): ProductDetailsInterface {
      return ProductDetails.state.productDetails
    },
    isLoading(): boolean {
      return ProductDetails.state.loading
    },
  },
  mounted() {
    this.getProductDetails()
  },
  created() {
    this.catalogId = this.$route.params.catalogId
    this.productId = this.$route.params.productId
  },
  methods: {
    getProductDetails() {
      ProductDetails.commit('setCatalogId', this.catalogId)
      ProductDetails.commit('setProductId', this.productId)

      ProductDetails.dispatch('getProductDetails')
    },
  },
})
